// import { Controller } from '@hotwired/stimulus';
import FileUploadController from '@controllers/portal/components/file_upload_controller';

export default class extends FileUploadController {
  currTarget = 0;
  
  static targets = ['input', 'submitButton'];
  
  static values = {
    imageSrc: String,
    hasImage: Boolean
  };

  connect() {
    // eslint-disable-next-line no-console
    console.log('Controller: Global::Modal::ModalOptionType connected!');
    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.src = this.imageSrcValue || '';
    }
  }
  
  inputChanged() {
    this.updateBtnState();
  }
  
  handleFileInputChange() {
    const shouldShowNextStep = super.canUploadFile();

    if (shouldShowNextStep) {
      // hide placeholder image
      if (this.hasPlaceholderImageTarget) {
        this.placeholderImageTarget.classList.add(this.hiddenClass);
      }

      // show preview image and add source
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.classList.remove(this.hiddenClass);
        this.previewImageTarget.src = URL.createObjectURL(this.file);
      }

      this.updateBtnState();
    }
  }
  
    updateBtnState() {
      const hasOptionName = this.inputTarget.value.trim().length > 0
      const hasImage = !!this.file || this.hasImageValue;
      // enable submit button
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = !(hasOptionName && hasImage);
      }
  }
}
